/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import NButton from '../../components/inputs/NButton';
import NInput from '../../components/inputs/NInput';
import { Form as FormikForm, Formik } from 'formik';
import { FeedbackValidation } from '../../validations/validation';
import useUserAPI from '../../hooks/network/useUserAPI';
import { errorToaster, successToaster } from '../toaster/Toaster';

const Transition = React.forwardRef((props, ref) => <Slide direction='up' ref={ref} {...props} />);

export function FeedbackModal(props) {
  const { saveFeedback, isLoading } = useUserAPI();

  const handleSubmit = async (values) => {
    try {
      const r = await saveFeedback({ message: values?.message });
      if (r?.success) {
        successToaster(r?.message || 'Feedback send successfully');
        props?.handleClose?.();
      }
    } catch {
      errorToaster('Something went wrong!');
    }
  };

  return (
    <Formik
      initialValues={{ message: '' }}
      validationSchema={FeedbackValidation}
      onSubmit={handleSubmit}
      enableReinitialize
      disableBackdropClick
    >
      {({ touched, values, errors, handleSubmit, handleChange, handleBlur }) => (
        <FormikForm autoComplete='off' onSubmit={handleSubmit}>
          <div className='w-full'>
            <Dialog
              fullWidth
              maxWidth='xs'
              open={props?.open}
              TransitionComponent={Transition}
              keepMounted
              onClose={() => props?.handleClose?.()}
              aria-describedby='alert-dialog-slide-description'
            >
              <DialogTitle className='bg-gray-200'>
                <div className='flex items-center justify-between'>
                  <p className='text-base font-semibold text-black'>Feedback</p>
                  <button className='m-0 p-0' type='button' onClick={() => props?.handleClose?.()}>
                    <CloseIcon />
                  </button>
                </div>
              </DialogTitle>
              <div className='flex flex-col items-center justify-center p-8'>
                <div className='mb-5 text-center font-medium text-black'>{props?.message}</div>
                <div className='mb-10 w-full'>
                  <NInput
                    type='text'
                    name='message'
                    label='Feedback'
                    value={values?.message}
                    error={errors.message && touched.message}
                    helperText={errors.message && touched.message ? errors.message : ''}
                    placeholder='Feedback'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    multiline
                    rows={7}
                  />
                </div>
                <div className='flex w-full items-center justify-center'>
                  <NButton
                    isLoading={isLoading}
                    type='button'
                    onClick={handleSubmit}
                    className=''
                    variant='Ncontained'
                  >
                    Submit
                  </NButton>
                </div>
              </div>
            </Dialog>
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}
